import { DayPicker, DayPickerProps } from "react-day-picker";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { format } from "date-fns";
import { useState } from "react";
import {
  calenderPickerClasses,
  calenderRootClasses,
  CalenderVariantProps,
  dayButtonClasses,
} from "./Calendar.style";
// import Select from "@/Select";

export type CalendarProps = CalenderVariantProps & {
  value?: Date;
  onChange?: (date: Date | undefined) => void;
  className?: string;
  disabled?: DayPickerProps["disabled"];
};

const Calendar = (props: CalendarProps) => {
  const { value, onChange, className, size, disabled } = props;
  const [month, setMonth] = useState<Date>(value || new Date());
  return (
    <div className={calenderRootClasses()}>
      <DayPicker
        disabled={disabled}
        mode="single"
        selected={value}
        onSelect={onChange}
        month={month}
        onMonthChange={setMonth}
        showOutsideDays={false}
        className={calenderPickerClasses({ className })}
        // animate
        // captionLayout="dropdown"
        components={{
          Nav: ({ onPreviousClick, onNextClick, className }) => {
            return (
              <nav
                className={`${className} flex items-center justify-around mb-4 gap-4`}
              >
                <button
                  onClick={onPreviousClick}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                  title="Previous month"
                >
                  <ChevronLeft className="size-5 text-gray-600" />
                </button>
                <h2 className="text-xl font-semibold text-gray-900">
                  {format(month, "MMMM yyyy")}
                </h2>
                <button
                  onClick={onNextClick}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                  title="Next month"
                >
                  <ChevronRight className="size-5 text-gray-600" />
                </button>
              </nav>
            );
          },
          CaptionLabel: (props) => {
            return <span {...props} className="sr-only" />;
          },
          MonthGrid: ({ children }) => {
            return <table className="w-full">{children}</table>;
          },
          Day: ({ children }) => {
            return <td className="text-center">{children}</td>;
          },
          DayButton: (props) => {
            const { modifiers, ...rest } = props;
            return (
              <button
                {...rest}
                disabled={modifiers.disabled}
                className={dayButtonClasses({
                  isOutside: modifiers.outside,
                  isSelected: modifiers.selected,
                  isToday: modifiers.today,
                  size: size,
                })}
              />
            );
          },
          DropdownNav(props) {
            return (
              <div
                {...props}
                className="flex justify-between sm:flex-row flex-col mb-4 gap-4"
              />
            );
          },

          // Dropdown(props) {
          //   const { value, options, onChange } = props;
          //   return (
          //     <Select
          //       defaultValue={value}
          //       value={value}
          //       onChange={(value) => {
          //         const syntheticEvent = {
          //           target: { value },
          //         } as React.ChangeEvent<HTMLSelectElement>;
          //         if (typeof onChange === "function") {
          //           onChange(syntheticEvent);
          //         }
          //       }}
          //       options={options}
          //     />
          //   );
          // },
        }}
      />
    </div>
  );
};

export default Calendar;
